
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/find-a-space",
      function () {
        return require("private-next-pages/find-a-space.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/find-a-space"])
      });
    }
  